import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import Card from '../UI/Card';

const ContactPreview: React.FC = () => {
  const contactInfo = [
    {
      icon: Phone,
      label: 'Phone',
      value: '+91 982 213 7676',
      href: 'tel:+919822137676'
    },
    {
      icon: Mail,
      label: 'Email',
      value: 'mirchirepublic@gmail.com',
      href: 'mailto:mirchirepublic@gmail.com'
    },
    {
      icon: MapPin,
      label: 'Address',
      value: 'Q-1, Fifth Floor, Silvio Heights, Opp. PWD Quarters, St. Inez, Panaji, Goa 403001',
      href: '#'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-neutral-50 via-white to-blue-50 dark:bg-dark-bg relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-brand-1/5 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-accent-1/5 to-transparent rounded-full blur-3xl"></div>
      
      <div className="container-grid relative z-10">
        <div className="col-span-12 text-center mb-16">
          <motion.h2
            className="text-4xl lg:text-5xl font-bold mb-6 text-brand-1"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Let's Create Something Amazing
          </motion.h2>
          <motion.p
            className="text-lg text-neutral-600 dark:text-neutral-400 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Ready to bring your vision to life? Get in touch with our team and let's discuss how we can make your next event extraordinary.
          </motion.p>
        </div>

        <div className="col-span-12">
          <div className="max-w-6xl mx-auto">
            {/* Company Info - Centered */}
            <motion.div
              className="space-y-8 mb-16 text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
             
            </motion.div>

            {/* Contact Info - Creative Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              {contactInfo.map((item, index) => {
                const colors = [
                  { bg: 'bg-gradient-to-br from-red-500 to-brand-1', icon: 'text-white', label: 'text-red-600', hover: 'hover:shadow-red-200' },
                  { bg: 'bg-gradient-to-br from-blue-500 to-accent-1', icon: 'text-white', label: 'text-blue-600', hover: 'hover:shadow-blue-200' },
                  { bg: 'bg-gradient-to-br from-purple-500 to-pink-500', icon: 'text-white', label: 'text-purple-600', hover: 'hover:shadow-purple-200' }
                ];
                const color = colors[index];
                
                return (
                  <motion.div
                    key={item.label}
                    className={`bg-white dark:bg-neutral-800 rounded-2xl p-6 shadow-lg ${color.hover} hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1`}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="flex flex-col items-center text-center space-y-4">
                      <div className={`w-16 h-16 ${color.bg} rounded-xl flex items-center justify-center shadow-lg transform transition-transform hover:scale-110`}>
                        <item.icon className={`w-8 h-8 ${color.icon}`} />
                      </div>
                      <div>
                        <p className={`text-sm font-semibold ${color.label} uppercase tracking-wide mb-2`}>
                          {item.label}
                        </p>
                        {item.href.startsWith('#') ? (
                          <p className="font-medium text-neutral-800 dark:text-neutral-200">{item.value}</p>
                        ) : (
                          <a
                            href={item.href}
                            className="font-medium text-neutral-800 dark:text-neutral-200 hover:text-brand-1 transition-colors duration-200 break-words"
                          >
                            {item.value}
                          </a>
                        )}
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPreview;